import { signal } from "@preact/signals-react"

export const sellerProductDetailsData = signal([])
export const isLoadingSellerProductsDetails = signal(true)